export default __webpack_public_path__ + "static/media/rbs.eabeb7ac.svg";